import React from 'react';
import styles from 'LearningManager/styles/CustomSetup.module.scss';

interface ConfigureState {
	assignmentName: string;
	certDuration: string;
	assignmentStart: string;
	dueDate: string;
}

interface ConfigureSettingsCardProps {
	configure: ConfigureState;
}

const formatChoice = (value: string) => {
	if (!value) return '-';

	const map: Record<string, string> = {
		'one-year': 'One year',
		custom: 'Custom expiration',
		never: 'Never expires',
		immediate: 'Immediate',
		schedule: 'Schedule',
		none: 'None',
		'one-time-assignment': 'One-Time Assignment',
		'ongoing-assignment': 'Ongoing Assignment'
	};

	return map[value] ?? value;
};

const ConfigureSettingsCard: React.FC<ConfigureSettingsCardProps> = ({
	configure
}) => {
	return (
		<div className={styles.summaryCard}>
			<div>
				<div className={styles.mutedLabel}>Name</div>
				<div className={styles.summaryValue}>
					{configure.assignmentName || '-'}
				</div>
			</div>

			<div className={styles.summaryGrid}>
				<div>
					<div className={styles.mutedLabel}>
						Certification Duration
					</div>
					<div className={styles.summaryValue}>
						{formatChoice(configure.certDuration)}
					</div>
				</div>
				<div>
					<div className={styles.mutedLabel}>Assignment Start</div>
					<div className={styles.summaryValue}>
						{formatChoice(configure.assignmentStart)}
					</div>
				</div>
				<div>
					<div className={styles.mutedLabel}>Due date</div>
					<div className={styles.summaryValue}>
						{formatChoice(configure.dueDate)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfigureSettingsCard;
